function n(){return"2.21.4"}export{n as getVersion};
